import axios from "axios";
import Cookies from "js-cookie";

const httpServicePlugin = {
  install(Vue, {store: store}) {
    axios.defaults.withCredentials = true
    // axios.defaults.baseURL = process.env.VUE_APP_API_URLja4Hq
    console.log(process.env.VUE_APP_API_URL);
    axios.defaults.baseURL = process.env.VUE_APP_API_URL ?? 'http://localhost:81/api'
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
    axios.defaults.headers['Accept'] = 'application/json'
    axios.defaults.headers['Content-Type'] = 'application/json'

    axios.interceptors.request.use(request => {
      request.headers['locale'] = store?.getters?.['i18n/locale'];

      const token = store?.getters?.['auth/token']
      const mobileToken = store?.getters?.['mobileBiometric/token']

      if (token) {
        request.headers.common.Authorization = `Bearer ${token}`
      }

      if (mobileToken) {
        request.headers['X-Mobile-Token'] = `Bearer ${mobileToken}`;
      }

      if (['post', 'put', 'delete'].includes(request.method) && !Cookies.get('XSRF-TOKEN')) {
        return setCSRFToken().then(() => request)
      }

      return request
    })

    const setCSRFToken = () => {
      return axios.get('/sanctum/csrf-cookie');
    }

    axios.interceptors.response.use(
      response => {
        return response
      },
      error => {
        switch (error.response.status) {
          case 401: // Not logged in
            store?.dispatch?.('auth/clear')
            break;
          case 419: // Session expired
          case 403: // Forbidden

            if (error.response.data.is_mobile_token) {
              store?.dispatch?.('mobileBiometric/logout')
              break;
            }

            if (store?.getters?.['auth/isOperator'])
              store?.dispatch?.('auth/logoutOperator')
            else
              store?.dispatch?.("auth/logout");
            break;
          default:
            // Allow individual requests to handle other errors
            return Promise.reject(error);
        }

        return Promise.reject(error);
      }
    );

    Vue.prototype.$axios = axios
    window.axios=Vue.prototype.$axios
  }
}

export default httpServicePlugin

